export default () => typeof chrome === 'object' && typeof chrome.runtime === 'object';
